/* BSAI – Estimado de entrega en hora de Ciudad de México. Editable: CUTOFF, FESTIVOS. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.BsaiEntrega = api; api.init(); }
})(typeof self !== 'undefined' ? self : this, function () {
  var TZ = 'America/Mexico_City';
  var CUTOFF_H = 14, CUTOFF_M = 0;
  var MOSTRAR_SEG = 5 * 3600; // solo mostrar "comprando antes de" con 5 h o menos
  // Descansos obligatorios LFT art. 74 (YYYY-MM-DD). Editar libremente.
  var FESTIVOS = [
    '2026-01-01', '2026-02-02', '2026-03-16', '2026-05-01', '2026-09-16', '2026-11-16', '2026-12-25',
    '2027-01-01', '2027-02-01', '2027-03-15', '2027-05-01', '2027-09-16', '2027-11-15', '2027-12-25'
  ];
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function mxParts(now) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    var p = {}; f.formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour, mi: +p.minute, s: +p.second };
  }
  function ymd(dt) { return dt.toISOString().slice(0, 10); } // dt = fecha UTC a medianoche
  function esHabil(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && FESTIVOS.indexOf(ymd(dt)) === -1; }
  function sig(dt) { return new Date(dt.getTime() + 864e5); }
  function sumarHabiles(dt, n) { while (n > 0) { dt = sig(dt); if (esHabil(dt)) n--; } return dt; }
  function fmt(dt) { return DIAS[dt.getUTCDay()] + ', ' + dt.getUTCDate() + ' de ' + MESES[dt.getUTCMonth()]; }

  function calcular(now, min, max) {
    var p = mxParts(now);
    var hoy = new Date(Date.UTC(p.y, p.m - 1, p.d));
    var segHoy = p.h * 3600 + p.mi * 60 + p.s, segCut = CUTOFF_H * 3600 + CUTOFF_M * 60;
    var aTiempo = esHabil(hoy) && segHoy < segCut;
    var inicio = hoy;
    if (!aTiempo) { inicio = sig(hoy); while (!esHabil(inicio)) inicio = sig(inicio); }
    var dMin = sumarHabiles(inicio, min), dMax = sumarHabiles(inicio, max);
    return { inicio: ymd(inicio), min: ymd(dMin), max: ymd(dMax), minTxt: fmt(dMin), maxTxt: fmt(dMax),
             restanteSeg: aTiempo ? segCut - segHoy : null };
  }
  function countdown(seg) {
    var h = Math.floor(seg / 3600), m = Math.ceil((seg % 3600) / 60);
    if (m === 60) { h++; m = 0; }
    var mt = m + (m === 1 ? ' minuto' : ' minutos'); if (h <= 0) return mt; var ht = h + (h === 1 ? ' hora' : ' horas'); return m > 0 ? ht + ' ' + mt : ht;
  }
  function fmtG(t) { return t.replace(', ', ' '); }
  function html(r, gratis) {
    var s = gratis
      ? 'Llega <span class="bsai-entrega__gratis">gratis</span> entre <b>' + fmtG(r.minTxt) + '</b> y <b>' + fmtG(r.maxTxt) + '</b>'
      : 'Llega entre <b>' + r.minTxt + '</b> y el <b>' + r.maxTxt + '</b>';
    if (r.restanteSeg !== null && r.restanteSeg <= MOSTRAR_SEG) s += ' comprando antes de <span class="bsai-entrega__countdown">' + countdown(r.restanteSeg) + '</span>';
    return s;
  }
  // Precio (centavos) de la variante seleccionada; respaldo: data-precio.
  function precio(el) {
    var p = +el.getAttribute('data-precio') || 0;
    try { var m = JSON.parse(el.getAttribute('data-precios') || '{}'), vi = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (vi && m[vi.value] != null) p = +m[vi.value]; } catch (e) {}
    return p;
  }
  function render(now) {
    var els = document.querySelectorAll('.bsai-entrega[data-min]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], t = el.querySelector('.bsai-entrega__text');
      if (t) t.innerHTML = html(calcular(now || (typeof window !== 'undefined' && window.BSAI_ENTREGA_NOW ? new Date(window.BSAI_ENTREGA_NOW) : new Date()), +el.dataset.min, +el.dataset.max), precio(el) > 50000);
    }
  }
  function init() {
    if (typeof document === 'undefined') return;
    var go = function () { render(); setInterval(function () { render(); }, 30000);
      document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('form[action*="/cart/add"], variant-selects, variant-radios')) setTimeout(function () { render(); }, 50); });
      document.addEventListener('variant:change', function () { setTimeout(function () { render(); }, 50); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  }
  return { calcular: calcular, countdown: countdown, html: html, render: render, init: init, FESTIVOS: FESTIVOS };
});
